import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TramiteSuperfinancieraDto } from '../dto/tramites/tramite-superfinanciera.dto';
import { TramiteResponseDTO } from '../dto/tramites/tramite.dto';

@Injectable({
  providedIn: 'root',
})
export class TramiteSuperfinancieraService {
  private apiUrl = environment.apiUrl;
  private baseUrl = '/superfinanciera/tramite';

  constructor(private http: HttpClient) {}

  postCrearTramite(
    data: TramiteSuperfinancieraDto
  ): Observable<TramiteSuperfinancieraDto> {
    return this.http.post<TramiteSuperfinancieraDto>(
      `${this.apiUrl}${this.baseUrl}`,
      data
    );
  }
}
